import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {SpineGSAPWrapper} from "../utils/SpineGSAPWrapper";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";


export class PlusFsView  extends PIXI.Container implements StageLayer {

    private spineWrappers: PIXI.Container [][] = [
        [new PIXI.Container(), new PIXI.Container(), new PIXI.Container()],
        [new PIXI.Container(), new PIXI.Container(), new PIXI.Container()],
        [new PIXI.Container(), new PIXI.Container(), new PIXI.Container()],
        [new PIXI.Container(), new PIXI.Container(), new PIXI.Container()],
        [new PIXI.Container(), new PIXI.Container(), new PIXI.Container()],
        [new PIXI.Container(), new PIXI.Container(), new PIXI.Container()]
    ];
    private bigSpine: PIXI.spine.Spine;
    private indicatorSpines: PIXI.spine.Spine [] = [];

    private spineAndAnimName: string = "+1";
    name = "PlusFsView";
    private startX: number = 0;
    private spinButtonPositionLandscape: PIXI.Point = new PIXI.Point(935, 536);
    private spinButtonPositionPortrait: PIXI.Point = new PIXI.Point(425, 961);

    private runningAnimations: gsap.core.Timeline [] = [];

    constructor() {
        super();
        // To binge os
        // [["M3","M3","M3"],["M2,M2,M3,XW","L5,XW","XW"],["XW","M2,M3,XW","M3,M2,L5,L4,L3,XW"],["XW","M4,XW","L5,L4,XW"],["XW","L5,L3,L2,M3,XW","M1,M5,M6,L5,L4,L3,M3,XW"],["M4","L3","M6"]]
    }

    public init() {
        this.createSpines();
        this.onResize();
        //this.debug();
    }

    private debug(): void {
        const ref = this;
        document.addEventListener("keydown", function (e) {

            const tl = gsap.timeline();

            switch (e.key) {
                case "1":
                    tl.add(ref.playSpineFromSymPos(2,0));
                    tl.add(() => {
                        ref.resetAnimations();
                    });
                break;

                case "2":
                    tl.add(ref.playIndicatorSpine(3, () => {
                        ref.resetAnimations()
                    }));
                break;

            }
        });

        //SlotGame.keypadPlugin.setZeroBetSpinCounter(99);
    }
    public resetAnimations(): void {
        this.runningAnimations.forEach((tl) => {
            tl.progress(1);
            tl.kill();
        });

        this.runningAnimations = [];
        this.onResize();
    }

    public playIndicatorSpine(indicatorIndex:number, callback: () => void = () => {}): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if(this.indicatorSpines[indicatorIndex]) {
            const spine: PIXI.spine.Spine = this.indicatorSpines[indicatorIndex];
            const point: PIXI.Point = (NolimitApplication.isLandscape)? this.spinButtonPositionLandscape : this.spinButtonPositionPortrait;

            tl.add(() => {
                spine.visible = true;
                spine.alpha = 1;
            });
            tl.add(SpineGSAPWrapper.createTimelineForAnimation(spine, 0, this.spineAndAnimName,false));
            tl.add(() => {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.FS_PLUS);
            }, "<");
            tl.add(gsap.to(spine, {
                duration: 0.5,
                x: point.x,
                y: point.y
            }), "-=0.25");
            tl.add(
                gsap.fromTo(spine, {
                    alpha: 0
                }, {
                    alpha: 1
            }), "<");
            tl.add([
                () => {
                    this.spinBtnFx.visible = true;
                },
                SpineGSAPWrapper.createTimelineForAnimation(this.spinBtnFx, 0, "animation", false),
                () => {
                    callback();
                }
            ]);
            tl.add(() => {
                this.spinBtnFx.visible = false;
            });


            this.runningAnimations.push(tl);
        }

        return tl;
    }

    public playSpineFromSymPos(rId:number, sId:number, callback: () => void = () => {}): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        const spine:PIXI.spine.Spine | undefined = <PIXI.spine.Spine>this.spineWrappers[rId][sId].getChildByName(this.spineAndAnimName);

        if(spine) {
            const point: PIXI.Point = (NolimitApplication.isLandscape)? this.spinButtonPositionLandscape : this.spinButtonPositionPortrait;

            tl.add(() => {
                this.spineWrappers[rId][sId].visible = true;
                spine.alpha = 1;
            }, 0);
            tl.add(SpineGSAPWrapper.createTimelineForAnimation(spine, 0, this.spineAndAnimName,false));
            tl.add(() => {
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.FS_PLUS);
            }, "<");
            tl.add(gsap.to(this.spineWrappers[rId][sId], {
                duration: 0.5,
                x: point.x,
                y: point.y
            }), "-=0.25");
            tl.add(
                gsap.fromTo(spine, {
                    alpha: 0
                }, {
                    alpha: 1
                })
            , "<");
            tl.add([
                () => {
                    this.spinBtnFx.visible = true;
                },
                SpineGSAPWrapper.createTimelineForAnimation(this.spinBtnFx, 0, "animation", false)
            ], "-=0.1");
            tl.add([
                () => {
                    callback();
                }
            ], "<");
            tl.add(() => {
                this.spinBtnFx.visible = false;
            });

            this.runningAnimations.push(tl);
        }

        return tl;
    }

    onResize() {
        this.spinBtnFx.position = (NolimitApplication.isLandscape)? this.spinButtonPositionLandscape : this.spinButtonPositionPortrait;
        this.spinBtnFx.scale.set((NolimitApplication.isLandscape)? 1 : 1.2);

        if(this.runningAnimations.length > 0) {
            this.resetAnimations();
        }

        if(NolimitApplication.isLandscape) {
            this.scale.set(1, 1);
            this.startX = 0;
            this.startY = 200;
            this.spineWrappers.forEach((containers, rId) => {
                const symbols = XwaysHoarder2.reelView.reels[rId].model.getAllVisibleSymbols();

                containers.forEach((container, sId) => {
                    const sym = symbols[sId].positionable;
                    if(sym) {
                        container.position.set(this.startX + ((sym.position.x - XwaysHoarder2Statics.symbolWidth/3)  + (rId * XwaysHoarder2Statics.symbolWidth))
                            , sym.position.y + this.startY);
                    }

                });
            });

            const indStartX:number = 100;
            const indStartY:number = 50;
            this.indicatorSpines.forEach((spine, index) => {
                spine.scale.set(0.85, 0.85);
                spine.position.set(indStartX + (index * 160), indStartY);
            });

            //this.bigSpine.position.set(360, 360);
        }
        else {

            this.startY = 330;
            this.startX = 100;
            this.scale.set(0.85, 0.85);

            this.spineWrappers.forEach((containers, rId) => {
                const symbols = XwaysHoarder2.reelView.reels[rId].model.getAllVisibleSymbols();

                containers.forEach((container, sId) => {
                    const sym = symbols[sId].positionable;
                    if(sym) {
                        container.position.set(this.startX + (((sym.position.x - XwaysHoarder2Statics.symbolWidth/3)  + (rId * XwaysHoarder2Statics.symbolWidth)) * 0.85),
                            (sym.position.y + this.startY) * 0.85);
                    }

                });
            });

            const indStartX:number = 205;
            const indStartY:number = 150;
            this.indicatorSpines.forEach((spine, index) => {
                spine.scale.set(0.65, 0.65);
                spine.position.set(indStartX + (index * 140), indStartY);
            });

            //this.bigSpine.position.set(400, 440);
        }

        // TODO: Put all running animations to progress 1
    }

    private startY: number = 200;
    private spinBtnFx: PIXI.spine.Spine;

    private createSpines(): void {
        // Setup containers
        this.spineWrappers.forEach((containers, rId) => {
            const symbols = XwaysHoarder2.reelView.reels[rId].model.getAllVisibleSymbols();

            containers.forEach((container, sId) => {
                const sym = symbols[sId].positionable;


                const spine: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.PLUS_ONE));
                spine.name = "+1";
                //spine.state.setAnimation(0, "+1", true);

                if(sym) {
                    container.position.set((sym.position.x - XwaysHoarder2Statics.symbolWidth/3)  + (rId * XwaysHoarder2Statics.symbolWidth), sym.position.y + this.startY);
                }
                this.addChild(container);


                container.addChild(spine);
                container.visible = false;
            });
        });

        [0, 1, 2, 3].forEach((indCount) => {
            const spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.PLUS_ONE));
            spine.visible = false;

            this.indicatorSpines.push(spine);
            this.addChild(spine);
        });

        this.spinBtnFx = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SPIN_BTN_FX));
        this.spinBtnFx.visible = false;
        //console.log("SPIN BTN FX", this.spinBtnFx.spineData.animations);
        //this.spinBtnFx.state.setAnimation(0, "animation", true);
        this.addChild(this.spinBtnFx);
    }


}